module.exports = __webpack_public_path__ + "static/media/quality.186c8155.png";